import { platform } from '@/defines/environment'
import { APP_CONFIG, ossUrl } from '@/defines/environment/config'
import { isMallApp } from '@mc/mc-base-env/src/web/platform'
import { NavButton, NativeEvent, Bridge } from '@mc/mc-jsbridge'
import { DialogAlert } from '@/utils/dialog.js'
import { navBar } from '@/utils/native_interactions/native_bar'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import { cmsPage } from './tracer/track_map/modules/cms_page'
// 0:取消 1: 微信聊天窗口 2: 朋友圈
const APPSHARE_CLICK = {
  cancel: 0,
  friend: 1,
  friendCircle: 2
}
// nav 导航 type
const APPNAV_POSITION = {
  left1: 1,
  left2: 2,
  right3: 3,
  right4: 4
}

export function getScanButton(layout) {
  const date = new Date().getTime()
  const icon = `${ossUrl}spruce_material/e668358dc142409d4cfda81bc57a2fb7?date=${date}`
  return new NavButton(
    {
      name: 'cmsShare',
      icon
    },
    () => {
      onAppShareBtnClick(layout, cmsPage.appWxShareBtnClick)
    }
  )
}

// 监听app按钮点击
export function onAppShareBtnClick(layout, spm) {
  tracerVuePlugin.click(spm)
  const eventId = NativeEvent.on('onShareResult', res => {
    if (res.ret) {
      DialogAlert('分享成功')
    } else {
      DialogAlert('分享失败')
    }
  })
  onAppShareMaskClick()
  const shareTitle = layout.share_name ? layout.share_name : layout.page_name
  const sharePic = layout.share_img ? layout.share_img : ''
  const shareLink = layout.share_url ? layout.share_url : window.location.href
  const shareDesc = layout.share_desc
    ? layout.share_desc
    : `快来${APP_CONFIG.app_name}看看吧`
  Bridge.openShareTool({
    pic: sharePic,
    url: shareLink,
    title: shareTitle,
    detail: shareDesc
  })
    .then(() => {
      // 移除事件监听
      NativeEvent.remove('onShareResult', eventId)
    })
    .catch(error => {
      console.log(error)
    })
}

export function onAppShareMaskClick() {
  const eventId = NativeEvent.on('onShareClick', res => {
    if (res.ret && res.data) {
      const { scene } = res.data
      switch (scene) {
        // 点击了取消
        case APPSHARE_CLICK.cancel:
          tracerVuePlugin.click(cmsPage.appWxShareCancel)
          break
        // 点击分享朋友
        case APPSHARE_CLICK.friend:
          tracerVuePlugin.click(cmsPage.appWxShareToFriend)
          break
        // 点击分享朋友圈
        case APPSHARE_CLICK.friendCircle:
          tracerVuePlugin.click(cmsPage.appWxShareToFriendCircle)
          break
        default:
          console.log('点击了其他' + scene)
      }
    }
    // 移除事件监听
    NativeEvent.remove('onShareClick', eventId)
  })
}
// 设置微信分享信息
export function setCmsWxShareInfo(layout) {
  if (platform === 'weixin') {
    const shareTitle = layout.share_name ? layout.share_name : layout.page_name
    const sharePic = layout.share_img ? layout.share_img : ''
    const shareLink = layout.share_url ? layout.share_url : window.location.href
    const shareDesc = layout.share_desc
      ? layout.share_desc
      : `快来${APP_CONFIG.app_name}看看吧`
    if (window.wx) {
      window.wx.ready(() => {
        // 需在用户可能点击分享按钮前就先调用
        if (window.wx.updateAppMessageShareData) {
          window.wx.updateAppMessageShareData({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: sharePic // 分享图标
          })
        }
        if (window.wx.updateTimelineShareData) {
          window.wx.updateTimelineShareData({
            title: shareTitle, // 分享标题
            link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: sharePic // 分享图标
          })
        }
      })
    }
  }
}

export function setCmsHeader(layout) {
  navBar.setTitle({ text: layout.page_name || APP_CONFIG.app_name })
  if (isMallApp()) {
    // cms二级页面导航设置导航
    if (layout.is_share) {
      const scanButton = getScanButton(layout)
      navBar.setButton(APPNAV_POSITION.right4, scanButton)
    }
  }
}
